import React, { useState, useEffect } from "react";
import { useCompany } from "../../Context/CompanyContext"; // Usar el contexto directamente
import { fetchWithAuth } from "../../Context/UserContext"; // Asumimos que se utiliza para las peticiones
import companyData from "../../Data/CompanyData";
import API_URL from "../../config";
import { Card, CardContent } from "../../components/ui/card";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { toast } from "sonner";

const Identificacion = () => {
  const { companies, fetchCompanies } = useCompany();
  const [editFormData, setEditFormData] = useState({
    company: {},
    profile: {}, // Asegurar la estructura inicial
  });
  const [error] = useState(""); // Estado para manejar errores
  const [pageError, setPageError] = useState(""); // Estado para el mensaje de error de página web

  useEffect(() => {
    if (companies?.company) {
      setEditFormData({
        company: { ...companies.company },
        profile: { ...companies.profile }, // Incluye la página web y otros campos
      });
    }
  }, [companies]);

  if (!editFormData?.company) {
    return <div className="text-muted-foreground">Cargando datos de la empresa...</div>;
  }

  const id_company = companies?.company?.id_company;

  const handleInputChange = (e, field) => {
    const value = e.target.value;
    if (field === "pagina_web") {
      const webPattern = /\.(com|org|net|edu|gov)(\.[a-z]{2})?$/i;
      if (!webPattern.test(value)) {
        setPageError(
          "El formato de la página web no es válido. Ejemplo: www.ejemplo.com"
        );
      } else {
        setPageError(""); // Limpia el mensaje de error si el formato es correcto
      }
    }
    setEditFormData({
      ...editFormData,
      [field]: value,
    });
  };

  const handleSaveInfo = async () => {
    if (error) {
      toast.error("Por favor, soluciona el error antes de guardar.");
      return;
    }

    try {
      const response = await fetchWithAuth(
        `${API_URL}/bs/company-profile/${id_company}/update`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            company: {
              nombre_empresa: editFormData.company.nombre_empresa,
              ruc: editFormData.company.ruc,
              verificado_empresa: editFormData.company.verificado_empresa,
              sector: editFormData.company.sector || companies.company.sector, // Incluye el sector de la empresa
              profile: {
                pagina_web: editFormData.profile?.pagina_web || "",
                // Agrega otros campos del perfil según sea necesario
              },
            },
          }),
        }
      );

      if (response.ok) {
        toast.success("Identificación de la empresa actualizada exitosamente.");
        fetchCompanies(); // Actualizar la lista de empresas en el contexto global
      } else {
        const data = await response.json();
        toast.error(`Error al actualizar la identificación: ${data.error}`);
      }
    } catch (error) {
      console.error("Error en la actualización de la identificación:", error);
      toast.error("Error al actualizar la identificación de la empresa.");
    }
  };

  const handleSectorChange = (e) => {
    const selectedSector = e.target.value;
    setEditFormData((prevFormData) => ({
      ...prevFormData,
      company: {
        ...prevFormData.company,
        sector: selectedSector,
      },
    }));
  };

  return (
    <Card>
      <CardContent className="space-y-4 pt-6">
        <h3 className="text-lg font-semibold text-foreground">Identificación de la Empresa</h3>

        <div>
          <label className="mb-1.5 block text-sm font-medium text-foreground">Nombre de la Empresa:</label>
          <Input
            type="text"
            value={editFormData.company?.nombre_empresa || ""}
            onChange={(e) =>
              setEditFormData((prevFormData) => ({
                ...prevFormData,
                company: {
                  ...prevFormData.company,
                  nombre_empresa: e.target.value,
                },
              }))
            }
          />
        </div>

        <div>
          <label className="mb-1.5 block text-sm font-medium text-foreground">Página Web:</label>
          <Input
            type="text"
            placeholder="Ejemplo: www.miempresa.com"
            value={editFormData?.profile.pagina_web || ""}
            onChange={(e) => handleInputChange(e, "pagina_web")}
          />
          {pageError && <p className="mt-1 text-sm text-destructive">{pageError}</p>}
        </div>

        <div>
          <label className="mb-1.5 block text-sm font-medium text-foreground">Sector:</label>
          <select
            value={editFormData.company?.sector || ""}
            onChange={handleSectorChange}
            className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
          >
            <option value="" disabled>
              Seleccione un sector
            </option>
            {companyData.sectores.map((sector) => (
              <option key={sector.label} value={sector.label}>
                {sector.label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="mb-1.5 block text-sm font-medium text-foreground">RUC:</label>
          <Input type="text" value={editFormData.company?.ruc || ""} disabled />
        </div>

        <div>
          <label className="mb-1.5 block text-sm font-medium text-foreground">Puntaje:</label>
          <Input
            type="text"
            value={
              editFormData.company?.puntaje
                ? `${editFormData.company.puntaje.promedio} (${editFormData.company.puntaje.num_reviews} reseñas)`
                : ""
            }
            disabled
          />
        </div>

        <div>
          <label className="mb-1.5 block text-sm font-medium text-foreground">Estado de Verificación:</label>
          <Input
            type="text"
            value={editFormData.company?.verificado_empresa ? "Empresa Verificada" : "Empresa no Verificada"}
            disabled
          />
        </div>

        <Button onClick={handleSaveInfo}>Guardar Cambios</Button>
      </CardContent>
    </Card>
  );
};

export default Identificacion;
